/* eslint-disable @typescript-eslint/no-unused-vars */
import { Card } from '../types';
import { readings } from './readings';
// Реекспортваме readings за достъп от другите файлове
export { readings } from './readings';
 export const cards = [

  {
    "card_id": "fool",
    "name": "Глупакът",
    "name_en": "The Fool",
    "number": "0",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-00-fool.jpg",
    "keywords": "Ново начало, спонтанност, доверие, идеализъм, скок във вярата",
    "this_is": "новото начало, спонтанността, скока във неизвестното.",
    "general_meaning": "Преди всичко, приключение и вяра, че ще се приземиш на краката си. Понякога предупреждава за наивност. Това е чистият потенциал преди пътешествието.",
    "advice": "Довери се на момента. Не планирай твърде много. Позволи си да бъдеш спонтанен.",
    "cardSymbolism": [
      "Младежът на ръба на пропастта – готовност за скок в неизвестното",
      "Малка торбичка – минал опит, пренесен напред",
      "Бяло цвете – чисти намерения, невинност",
      "Кучето – инстинктът, който го предпазва, приятел",
      "Планините в далечината – предстоящите предизвикателства"
    ],
    "reversed": "Безразсъдство, риск, глупави решения, липса на план",
    "planet": "Уран",
    "zodiac_sign": "Не фиксиран",
    "as_situation": "Започваш нов проект, пътуване или приключение. Несигурно е, но вълнуващо. Трябва да скочиш, без да знаеш какво има долу.",
    "as_lesson": "Понякога трябва да скочиш, без да знаеш къде ще паднеш. Вярата е по-важна от сигурността."
  },
  {
    "card_id": "magician",
    "name": "Магьосникът",
    "name_en": "The Magician",
    "number": "I",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-01-magician.jpg",
    "keywords": "Проявление, воля, умение, концентрация, действие",
    "this_is": "проявлението, уменията, волята.",
    "general_meaning": "Имаш всички инструменти, от които се нуждаеш, за да успееш. Време е да действаш и да твориш реалността си. Концентрирай намерението си.",
    "advice": "Действай сега. Не чакай \"подходящия момент\" - той е сега. Вярвай в способностите си.",
    "cardSymbolism": [
      "Масата с четирите елемента – владеене на всички сфери",
      "Ръката горе, другата долу – 'Както горе, така и долу'",
      "Безкрайност над главата – вечна мъдрост, безкрайни възможности",
      "Змията Уроборос – цикъл на живота, трансформация"
    ],
    "reversed": "Манипулация, неизползван талант, блокирана енергия, липса на посока",
    "planet": "Меркурий",
    "zodiac_sign": "Не фиксиран",
    "as_situation": "Имаш всички ресурси, за да постигнеш целта си. Момент за действие, не за чакане. Всичко е налице.",
    "as_lesson": "Ти имаш силата да създаваш реалността си. Използвай инструментите, които са ти дадени."
  },
  {
    "card_id": "high_priestess",
    "name": "Висшата жрица",
    "name_en": "The High Priestess",
    "number": "II",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-02-high-priestess.jpg",
    "keywords": "Тайна, интуиция, вътрешен глас, духовност, мълчание",
    "this_is": "интуицията, тайните, подсъзнанието.",
    "general_meaning": "Слушай вътрешния си глас. Отговорите не са на повърхността, а дълбоко в теб. Време за мълчание и търпение. Тя пази вратата към скритата мъдрост.",
    "advice": "Мълчи и слушай. Отговорите са вътре в теб, не вън. Довери се на сънищата и интуицията си.",
    "cardSymbolism": [
      "Завесата – тънката граница между видимото и невидимото",
      "Свитъкът със скрито знание – мъдрост, която не се разкрива на всеки",
      "Двете колони – светлина и тъмнина, вход към храма",
      "Полумесецът – власт над интуицията и циклите",
      "Водата – подсъзнание, дълбочина"
    ],
    "reversed": "Повърхностност, потисната интуиция, тайни, които тежат, липса на вътрешна връзка",
    "planet": "Луна",
    "zodiac_sign": "Не фиксиран",
    "as_situation": "Нещо е скрито, има тайна. Не всичко е каквото изглежда. Трябва да слушаш интуицията си, не думите на другите.",
    "as_lesson": "Истината не се казва с думи, а се усеща със сърцето. Слушай вътрешния си глас."
  },
  {
    "card_id": "empress",
    "name": "Императрицата",
    "name_en": "The Empress",
    "number": "III",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-03-empress.jpg",
    "keywords": "Творчество, изобилие, плодородие, майчинство, природа",
    "this_is": "плодородието, майчинството, природата, изобилието.",
    "general_meaning": "Тя е съзидателната сила на Вселената. Означава растеж, красота, грижа и разцвет във всички сфери. Приеми изобилието.",
    "advice": "Грижи се за себе си и за другите. Отглеждай това, което си посял. Позволи си да получаваш.",
    "cardSymbolism": [
      "Бременната жена на трон – плодородие, изобилие",
      "Златна нива – реколта, изобилие",
      "Венец от звезди – връзка с небето, духовна корона",
      "Водопад – живот, емоции, поток",
      "Жезъл в ръката – власт над живия свят"
    ],
    "reversed": "Блокирано творчество, безплодие, зависимост, задушаваща грижа, липса на растеж",
    "planet": "Венера",
    "zodiac_sign": "Не фиксиран",
    "as_situation": "Нещата цъфтят, раждат се, умножават се. Бременност, нов проект, който расте. Изобилие и красота.",
    "as_lesson": "Когато даваш любов и грижа, всичко около теб цъфти. Творчеството е естествено състояние."
  },
  {
    "card_id": "emperor",
    "name": "Императорът",
    "name_en": "The Emperor",
    "number": "IV",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-04-emperor.jpg",
    "keywords": "Власт, стабилност, ред, контрол, дисциплина",
    "this_is": "властта, структурата, авторитета, бащината фигура.",
    "general_meaning": "Време за ред, стабилност и установяване на граници. Трябва да поемеш контрол със здрава ръка. Той гради царство от хаоса.",
    "advice": "Бъди твърд, когато трябва. Установи ред в хаоса. Поеми отговорност за властта си.",
    "cardSymbolism": [
      "Каменен трон – твърдост, непоклатимост",
      "Брада – мъдрост, зрялост, авторитет",
      "Сферата – власт над света",
      "Червено наметало – страст, войнственост",
      "Планини – структура, твърдост"
    ],
    "reversed": "Тирания, слабост, безсилие, липса на дисциплина, злоупотреба с власт",
    "planet": "Марс",
    "zodiac_sign": "Овен",
    "as_situation": "Нужда от структура и ред. Вземане на важни решения. Установяване на правила и граници.",
    "as_lesson": "Без структура има хаос. Научи се да поставяш граници и да ги защитаваш."
  },
  {
    "card_id": "hierophant",
    "name": "Йерофантът",
    "name_en": "The Hierophant",
    "number": "V",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-05-hierophant.jpg",
    "keywords": "Традиция, духовност, учител, принадлежност, ритуал",
    "this_is": "традициите, духовния учител, съответствието с нормите.",
    "general_meaning": "Придържане към общоприетите правила, брак, институции или търсене на мъдрост от установен източник. Понякога означава и конформизъм.",
    "advice": "Потърси учител или ментор. Следвай традициите, които имат смисъл за теб. Принадлежността лекува.",
    "cardSymbolism": [
      "Двамата слуги – последователите, приемане на ученията",
      "Трите нива на кръста – трите свята",
      "Ръката в благословия – предаване на свещеното знание",
      "Колоните – знанието се споделя"
    ],
    "reversed": "Бунт срещу традициите, догматизъм, фалшив гуру, отхвърляне на общността",
    "planet": "Сатурн",
    "zodiac_sign": "Телец",
    "as_situation": "Сключване на брак, официален съюз. Търсене на духовен учител. Присъединяване към група или институция.",
    "as_lesson": "Понякога трябва да следваме традициите, за да намерим себе си. Има мъдрост в това, което е било преди нас."
  },
  {
    "card_id": "lovers",
    "name": "Влюбените",
    "name_en": "The Lovers",
    "number": "VI",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-06-lovers.jpg",
    "keywords": "Любов, избор, връзка, ценности, решение",
    "this_is": "любовта, избора, сърдечната връзка.",
    "general_meaning": "Основен избор (не само между двама души, а и между ценности), който определя съдбата ти. Следвай сърцето си и поеми отговорност за решението.",
    "advice": "Избери със сърцето, но не забравяй ума. След като избереш, не се съмнявай.",
    "cardSymbolism": [
      "Мъж и жена – Адам и Ева, невинност, избор",
      "Ангел Рафаил – благословия, висша връзка",
      "Дървото на познанието – страст, изкушение",
      "Дървото на живота – сила, страст",
      "Планината – целта след избора"
    ],
    "reversed": "Дисхармония, раздяла, грешен избор, изневяра, неспособност за избор",
    "planet": "Меркурий",
    "zodiac_sign": "Близнаци",
    "as_situation": "Любовна връзка, важна среща. Момент на избор, който ще определи бъдещето. Изпитване на ценностите.",
    "as_lesson": "Всеки избор носи отговорност. Няма правилен или грешен - има твой."
  },
  {
    "card_id": "chariot",
    "name": "Колесницата",
    "name_en": "The Chariot",
    "number": "VII",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-07-chariot.jpg",
    "keywords": "Победа, воля, контрол, увереност, движение",
    "this_is": "победата, волята, контрола над противоположностите.",
    "general_meaning": "Тръгваш смело напред, воден от амбиция. Трябва да удържиш контрол, за да спечелиш. Укроти вътрешните си противоречия.",
    "advice": "Управлявай емоциите си, не позволявай те да управляват теб. Насочи енергията си в една посока.",
    "cardSymbolism": [
      "Колесничарят извън града – завладява света",
      "Двете сфинкса – противоречиви сили, които трябва да бъдат контролирани",
      "Звездна корона – духовна светлина, вдъхновение",
      "Квадратът на гърдите – материята, която управлява",
      "Крилата – защита, победа"
    ],
    "reversed": "Липса на контрол, хаос, провал, агресия, загуба на посока",
    "planet": "Марс",
    "zodiac_sign": "Рак",
    "as_situation": "Пътуване, движение напред. Победа след усилие. Контрол над хаоса. Успех.",
    "as_lesson": "За да спечелиш, трябва да опитомиш вътрешните си противоречия. Контролът започва отвътре."
  },
  {
    "card_id": "strength",
    "name": "Сила",
    "name_en": "Strength",
    "number": "VIII",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-08-strength.jpg",
    "keywords": "Смелост, търпение, състрадание, вътрешна сила",
    "this_is": "вътрешната сила, смелостта, състраданието.",
    "general_meaning": "Истинската сила идва от контрол над емоциите и нежност, а не от груба физическа мощ. Опитоми дивака в себе си с любов.",
    "advice": "Не се бий с лъва - опитоми го със спокойствие и разбиране. Страховете ти не са врагове.",
    "cardSymbolism": [
      "Жената отваря устата на лъв – нежност побеждава грубата сила",
      "Лъвът – страсти, его, животинска природа",
      "Безкрайност над главата – духовна сила, мъдрост",
      "Цветята – цивилизация, красота",
      "Бялата рокля – чистота на намеренията"
    ],
    "reversed": "Слабост, съмнение в себе си, страх, животински инстинкти, агресия",
    "planet": "Слънце",
    "zodiac_sign": "Лъв",
    "as_situation": "Справяне със страхове. Нужда от търпение, не от агресия. Опитомяване на \"дивите\" части от живота.",
    "as_lesson": "Най-големите битки се печелят с търпение и любов, не с агресия."
  },
  {
    "card_id": "hermit",
    "name": "Отшелникът",
    "name_en": "The Hermit",
    "number": "IX",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-09-hermit.jpg",
    "keywords": "Самота, мъдрост, търсене, уединение, духовен път",
    "this_is": "самотата, себепознанието, търсенето на мъдрост.",
    "general_meaning": "Време да се отдръпнеш от суетата, да влезеш в себе си и да потърсиш вътрешна светлина. Самотата не е самата, а търсене.",
    "advice": "Оттегли се за малко. Потърси себе си. Не се страхувай от самотата - тя е учител.",
    "cardSymbolism": [
      "Старецът – мъдрост, опит, знание",
      "Фенерът – светлина в тъмнината, малката истина",
      "Тоядгата – опора, подкрепа в пътуването",
      "Планината – висша цел",
      "Снегът – самота, чистота, пречистване"
    ],
    "reversed": "Изолация, депресия, загубен път, страх от хора, бягство от света",
    "planet": "Сатурн",
    "zodiac_sign": "Дева",
    "as_situation": "Оттегляне от света. Време за размисъл и самота. Търсене на отговори. Духовно пътешествие.",
    "as_lesson": "Истината не се намира на шумните места, а в тишината на самотата."
  },
  {
    "card_id": "wheel_of_fortune",
    "name": "Колелото на съдбата",
    "name_en": "Wheel of Fortune",
    "number": "X",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-10-wheel-of-fortune.jpg",
    "keywords": "Съдба, цикъл, промяна, късмет, обрати",
    "this_is": "цикличността, съдбата, неизбежната промяна.",
    "general_meaning": "Животът се върти. Очаквай обрат (добър или лош) – каквото е било горе, ще бъде и долу. Приеми, че не всичко е под твой контрол.",
    "advice": "Приеми, че не всичко зависи от теб. Понякога трябва да се оставиш на течението.",
    "cardSymbolism": [
      "Колелото – постоянно движение, промяна",
      "Сфинксът – мъдрост, която държи равновесие",
      "Анубис – растеж, прогрес",
      "Змията – разруха, необходимост да се пусне",
      "Четирите същества – фиксираните зодии"
    ],
    "reversed": "Лош късмет, съпротива срещу промяната, застой, нежелание да приемеш циклите",
    "planet": "Юпитер",
    "zodiac_sign": "Не фиксиран",
    "as_situation": "Промяна, която идва отвън. Неконтролируеми събития. Късмет или обрат. Край на цикъл.",
    "as_lesson": "Нищо не е вечно - нито лошото, нито доброто. Научи се да плуваш с течението."
  },
  {
    "card_id": "justice",
    "name": "Справедливост",
    "name_en": "Justice",
    "number": "XI",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-11-justice.jpg",
    "keywords": "Справедливост, истина, баланс, карма, отговорност",
    "this_is": "истината, кармата, баланса, закона.",
    "general_meaning": "Получаваш това, което заслужаваш. Време за честни решения и поемане на отговорност. Везната винаги се изравнява.",
    "advice": "Бъди честен със себе си и с другите. Приеми последствията. Търси истината, колкото и да боли.",
    "cardSymbolism": [
      "Везните – претегляне на делата, кармичен баланс",
      "Мечът – истината, която сече безмилостно",
      "Короната – власт, авторитет",
      "Лилавото наметало – достойнство",
      "Седналата фигура – законът е непоклатим"
    ],
    "reversed": "Несправедливост, дисбаланс, лъжа, измама, отказ от отговорност",
    "planet": "Венера",
    "zodiac_sign": "Везни",
    "as_situation": "Съдебно дело, договор, важно решение. Момент на истина. Възстановяване на баланс.",
    "as_lesson": "Всичко, което правиш, се връща. Поеми отговорност за действията си."
  },
  {
    "card_id": "hanged_man",
    "name": "Обесеният",
    "name_en": "The Hanged Man",
    "number": "XII",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-12-hanged-man.jpg",
    "keywords": "Предаване, изчакване, нова гледна точка, жертва",
    "this_is": "преосмислянето, саможертвата, новата гледна точка.",
    "general_meaning": "Доброволно спиране или изчакване. Виждаш нещата от друга страна, за да намериш просветление. Понякога трябва да се предадеш, за да спечелиш.",
    "advice": "Престани да дърпаш конците. Остави се. Погледни проблема от друг ъгъл.",
    "cardSymbolism": [
      "Обесен за единия крак – доброволна жертва, не страда",
      "Обърнатата поза – различна гледна точка",
      "Ръцете зад гърба – не може да действа, нужно е търпение",
      "Дървото – живот, кръст, световно дърво",
      "Нимб – духовност, просветление"
    ],
    "reversed": "Апатия, застой, безсмислена жертва, съпротива, невъзможност да пуснеш",
    "planet": "Нептун",
    "zodiac_sign": "Риби",
    "as_situation": "Застой, изчакване. Не можеш да действаш, трябва да чакаш. Гледаш на нещата от друг ъгъл.",
    "as_lesson": "Понякога трябва да спреш да се бориш, за да спечелиш. Предаването не е слабост."
  },
  {
    "card_id": "death",
    "name": "Смърт",
    "name_en": "Death",
    "number": "XIII",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-13-death.jpg",
    "keywords": "Край, трансформация, освобождаване, прераждане",
    "this_is": "края, трансформацията, освобождаването.",
    "general_meaning": "НЕ означава физическа смърт. Това е символ на дълбок край, който проправя път за нещо ново. Трябва да оставиш старото да умре, за да се роди новото.",
    "advice": "Не се страхувай от края. Той е просто начало на нещо друго. Пусни.",
    "cardSymbolism": [
      "Скелетът – нищо не може да спре смъртта",
      "Косата – пожънва всичко, безмилостен край",
      "Кралят мъртъв – властта пада пред промяната",
      "Детето – приема, но не умира",
      "Изгряващото слънце – новото начало след края"
    ],
    "reversed": "Страх от промяна, застой, невъзможност да пуснеш, задържане на мъртвото",
    "planet": "Плутон",
    "zodiac_sign": "Скорпион",
    "as_situation": "Край на връзка, работа, период от живот. Трансформация. Трябва да пуснеш старото.",
    "as_lesson": "За да дойде новото, старото трябва да си отиде. Пускането е необходимо."
  },
  {
    "card_id": "temperance",
    "name": "Умереност",
    "name_en": "Temperance",
    "number": "XIV",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-14-temperance.jpg",
    "keywords": "Баланс, хармония, търпение, умереност, синтез",
    "this_is": "баланса, хармонията, търпението, златната среда.",
    "general_meaning": "Смесване на противоположности, за да се създаде нещо ново. Време за умереност и дългосрочен подход. Открий потока.",
    "advice": "Не бързай. Не прекалявай. Намери средния път и се придържай към него.",
    "cardSymbolism": [
      "Ангелът – висша защита",
      "Двете чаши – смесване на духовно и материално",
      "Единият крак във водата – подсъзнание, емоции",
      "Другият крак на сушата – материя, реалност",
      "Пътеката към планината – бавен, но сигурен път"
    ],
    "reversed": "Дисбаланс, крайности, нетърпение, конфликт, липса на хармония",
    "planet": "Юпитер",
    "zodiac_sign": "Стрелец",
    "as_situation": "Нужда от баланс. Смесване на различни елементи. Търпение и умереност. Лекуване.",
    "as_lesson": "Истината не е в крайностите, а по средата. Научи се да балансираш."
  },
  {
    "card_id": "devil",
    "name": "Дяволът",
    "name_en": "The Devil",
    "number": "XV",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-15-devil.jpg",
    "keywords": "Зависимост, плен, материално, илюзия, тъмнина",
    "this_is": "привързаността, зависимостта, материализма, сенките.",
    "general_meaning": "Чувстваш се в капан от собствените си желания, страхове или зависимости. Това е илюзия – ти имаш ключа. Изправи се пред сянката си.",
    "advice": "Погледни какво те държи в плен. Това, от което се страхуваш да се откажеш, може би те убива.",
    "cardSymbolism": [
      "Дяволът – егото, материята, животинската природа",
      "Мъж и жена с вериги – оковани, но веригите са свободни",
      "Опашките – животинска страст",
      "Обърната пентаграма – материята управлява духа",
      "Черен трон – материализъм"
    ],
    "reversed": "Освобождение, преодоляване на зависимости, излизане от плена, прозрение",
    "planet": "Сатурн",
    "zodiac_sign": "Козирог",
    "as_situation": "Зависимост - към вещества, човек, пари. Плен на материята. Чувстваш се в капан.",
    "as_lesson": "Сами създаваме оковите си. И сами можем да ги свалим."
  },
  {
    "card_id": "tower",
    "name": "Кулата",
    "name_en": "The Tower",
    "number": "XVI",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-16-tower.jpg",
    "keywords": "Срив, внезапна промяна, разруха, освобождение",
    "this_is": "внезапния срив, разрушаването, освобождението.",
    "general_meaning": "Нещо, на което си вярвал, се срутва изведнъж. Болезнено е, но освобождава от фалшиви основи. Понякога трябва да се разруши, за да се построи наново.",
    "advice": "Не се опитвай да спасяваш рушащото се. Позволи му да падне. След това започни отначало.",
    "cardSymbolism": [
      "Кулата се разрушава – човешка гордост, фалшиви ценности",
      "Мълнията – внезапен удар от съдбата",
      "Пламъците – огън на пречистване",
      "Падащите хора – сваляне на авторитети и егота",
      "Короните падат – загуба на статус"
    ],
    "reversed": "Забавен срив, избягване на промяната, страх от крах, опит да задържиш рушащото се",
    "planet": "Марс",
    "zodiac_sign": "Не фиксиран",
    "as_situation": "Внезапен обрат - развод, загуба на работа, инцидент. Всичко се срива. Край на илюзия.",
    "as_lesson": "Понякога трябва всичко да рухне, за да построиш наново, но по-истински."
  },
  {
    "card_id": "star",
    "name": "Звездата",
    "name_en": "The Star",
    "number": "XVII",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-17-star.jpg",
    "keywords": "Надежда, лечение, вдъхновение, мир, обновление",
    "this_is": "надеждата, вдъхновението, духовното изцеление.",
    "general_meaning": "След бурята идва спокойствие. Време за вяра, оптимизъм и връзка с Вселената. Води те светлина напред.",
    "advice": "Вярвай, че всичко ще бъде наред. Лекувай раните си с любов. Гледай напред.",
    "cardSymbolism": [
      "Жената – смирение, връзка със земята и небето",
      "Двете урни – смесване на подсъзнание и материя",
      "Звездите – седемте свята, водачество",
      "Птицата – свобода, трансформация",
      "Цъфтяща земя – нов живот, надежда"
    ],
    "reversed": "Загуба на надежда, отчаяние, липса на вяра, депресия, невъзможност да продължиш",
    "planet": "Уран",
    "zodiac_sign": "Водолей",
    "as_situation": "Лекуване на рани. Ново вдъхновение. Спокойствие след буря. Надежда за бъдещето.",
    "as_lesson": "След всяка тъмнина идва светлина. Вярата лекува всичко."
  },
  {
    "card_id": "moon",
    "name": "Луната",
    "name_en": "The Moon",
    "number": "XVIII",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-18-moon.jpg",
    "keywords": "Страх, илюзия, подсъзнание, съмнение, нощно пътешествие",
    "this_is": "илюзиите, страховете, подсъзнанието, интуицията.",
    "general_meaning": "Нещата не са такива, каквито изглеждат. Трябва да преминеш през страховете си, за да намериш истината. Довери се на интуицията в мрака.",
    "advice": "Не бягай от страховете си. Премини през тъмнината. Тя води към светлина.",
    "cardSymbolism": [
      "Луната – студена светлина, отразена, не истинска",
      "Кучето и вълкът – страховете, които вият",
      "Ракът – първична форма на живот, подсъзнание",
      "Пътеката – дълъг и труден път",
      "Кулите – портал към неизвестното"
    ],
    "reversed": "Излизане от илюзиите, преодоляване на страхове, яснота, край на объркването",
    "planet": "Луна",
    "zodiac_sign": "Риби",
    "as_situation": "Обърканост, несигурност. Не виждаш ясно. Страхове изплуват. Пътуване в тъмното.",
    "as_lesson": "Трябва да преминеш през страховете си, за да стигнеш до светлината."
  },
  {
    "card_id": "sun",
    "name": "Слънцето",
    "name_en": "The Sun",
    "number": "XIX",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-19-sun.jpg",
    "keywords": "Радост, успех, яснота, щастие, топлина",
    "this_is": "радостта, успеха, жизнеността, яснотата.",
    "general_meaning": "Най-щастливата карта. Топлина, постижения, истина и празнуване на живота. Всичко е осветено и ясно.",
    "advice": "Радвай се. Наслаждавай се на момента. Ти заслужаваш това щастие.",
    "cardSymbolism": [
      "Голямото слънце – животворна енергия, светлина",
      "Детето на кон – невинност, чиста радост",
      "Белият кон – сила, благородство, успех",
      "Слънчогледите – растеж, вяра",
      "Стената – опасността е зад гърба"
    ],
    "reversed": "Временна тъга, облачност, забавена радост, малки проблеми, които помрачават",
    "planet": "Слънце",
    "zodiac_sign": "Лъв",
    "as_situation": "Успех, радост, щастлив период. Всичко е ясно и топло. Детска радост.",
    "as_lesson": "Щастието е просто. То е в малките неща. Заслужаваш да бъдеш щастлив."
  },
  {
    "card_id": "judgement",
    "name": "Страшният съд",
    "name_en": "Judgement",
    "number": "XX",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-20-judgement.jpg",
    "keywords": "Пробуждане, прошка, прераждане, призвание, равносметка",
    "this_is": "прераждането, призванието, прошката, пробуждането.",
    "general_meaning": "Чуваш \"зов\" да се върнеш към истинската си същност. Време е за възкресение на надеждите. Прости си и започни отначало.",
    "advice": "Чуй вътрешния си зов. Прости на себе си за миналото. Стани от гробницата и живей.",
    "cardSymbolism": [
      "Ангел с тръба – божественият зов, събуждането",
      "Знамето – спасение, възкресение",
      "Мъртвите стават – миналото оживява, за да бъде простено",
      "Планините – новата цел след събуждането",
      "Семейството – всички са призовани"
    ],
    "reversed": "Съмнение в себе си, непрошка, отказ от призвание, страх от новото",
    "planet": "Плутон",
    "zodiac_sign": "Не фиксиран",
    "as_situation": "Момент на равносметка. Прошка към себе си или другите. Пробуждане. Чуваш призвание.",
    "as_lesson": "Никога не е твърде късно да започнеш отначало. Прости си и продължи."
  },
  {
    "card_id": "world",
    "name": "Светът",
    "name_en": "The World",
    "number": "XXI",
    "arcana": "Големи аркани",
    "filter": "major",
    "image": "images/major-21-world.jpg",
    "keywords": "Завършек, успех, цялост, пътешествие, хармония",
    "this_is": "завършек, цялост, интеграция, пътуване.",
    "general_meaning": "Успешно завършване на цикъл. Чувстваш се цялостен и в хармония с Вселената. Танцуваш в центъра на своя свят.",
    "advice": "Празнувай постижението си. Ти завърши този цикъл. Бъди горд. Готви се за следващото.",
    "cardSymbolism": [
      "Танцуващата жена – душата, завършила пътя си",
      "Лавровият венец – успех, завършеност, Вселената",
      "Четирите същества – четирите елемента, всичко е в баланс",
      "Жезлите – магията е завършена",
      "Пурпурната лента – вечност, безкрайност"
    ],
    "reversed": "Незавършеност, застой, липса на завършек, чувство за непълнота",
    "planet": "Сатурн",
    "zodiac_sign": "Не фиксиран",
    "as_situation": "Завършек на дълъг период. Успех, признание. Пътуване, което приключва. Интеграция.",
    "as_lesson": "Пътят има край, но той е и ново начало. Ти си всичко, от което се нуждаеш."
  },
  {
    "card_id": "ace_wands",
    "name": "Асо Жезли",
    "name_en": "Ace of Wands",
    "number": "1",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-01-ace.jpg",
    "keywords": "Искра, вдъхновение, ново начало, енергия за действие",
    "this_is": "искрата, новото начало, вдъхновението, потенциал.",
    "general_meaning": "Получаваш творческа енергия и ентусиазъм за нещо ново. Време е да запалиш огъня.",
    "advice": "Запали се за нещо ново. Идеята е тук - действай!",
    "cardSymbolism": [
      "Ръка от облак държи жезъл – дар свише",
      "Цъфтящ жезъл – растеж, жизненост, потенциал",
      "Замък в далечината – целта, която предстои да бъде завладяна",
      "Река – поток на съзнанието, движение напред"
    ],
    "reversed": "Липса на вдъхновение, блокирана енергия, отказ от начало",
    "planet": "Марс",
    "zodiac_sign": "Овен",
    "as_situation": "Нова идея те удря като мълния. Запален си да започнеш нещо.",
    "as_lesson": "Една искра може да запали цяла гора. Не подценявай малките начала."
  },
  {
    "card_id": "two_wands",
    "name": "Двойка Жезли",
    "name_en": "Two of Wands",
    "number": "2",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-02-two.jpg",
    "keywords": "Избор, планиране, поглед напред, смелост",
    "this_is": "планирането, избора, гледането напред.",
    "general_meaning": "Постигнал си нещо, а сега гледаш към хоризонта и планираш следващия ход. Светът е пред теб.",
    "advice": "Планирай, но не прекалявай. Избери посока и тръгни.",
    "cardSymbolism": [
      "Човек с жезъл в ръка, друг забит в стената – държане на опциите",
      "Глобус в ръцете – потенциал за пътуване и разрастване",
      "Гледна точка отвисоко – виждане надалеч",
      "Лилия и роза – баланс и чистота"
    ],
    "reversed": "Липса на план, страх от избор, нерешителност",
    "planet": "Марс",
    "zodiac_sign": "Овен",
    "as_situation": "Трябва да избереш посока. Планираш бъдещето. Гледаш напред.",
    "as_lesson": "Светът е пред теб. Но трябва да избереш посока."
  },
  {
    "card_id": "three_wands",
    "name": "Тройка Жезли",
    "name_en": "Three of Wands",
    "number": "3",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-03-three.jpg",
    "keywords": "Търпение, очакване на резултати, разширяване на хоризонтите",
    "this_is": "разширяването, търпението, чакането на резултати.",
    "general_meaning": "Изпратил си корабите в морето. Сега трябва да изчакаш търпеливо те да се завърнат с успех.",
    "advice": "Бъди търпелив. Резултатите идват. Разшири хоризонтите си.",
    "cardSymbolism": [
      "Гърбът на човека е обърнат – гледа към бъдещето, не към миналото",
      "Три жезли в земята – стабилна основа, върху която се гради",
      "Кораби в далечината – търговия, идеи на път да се завърнат",
      "Жълто небе – оптимизъм и надежда"
    ],
    "reversed": "Нетърпение, забавени резултати, разочарование",
    "planet": "Слънце",
    "zodiac_sign": "Овен",
    "as_situation": "След като си действал, чакаш резултати. Търпение. Разширяване на бизнес.",
    "as_lesson": "След като си посял, трябва да чакаш да поникне."
  },
  {
    "card_id": "four_wands",
    "name": "Четворка Жезли",
    "name_en": "Four of Wands",
    "number": "4",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-04-four.jpg",
    "keywords": "Празник, завръщане у дома, постижение, хармония",
    "this_is": "празника, хармонията, завръщането у дома.",
    "general_meaning": "Постигнал си стабилност. Време е да отпразнуваш с близките и да се порадваш на труда си.",
    "advice": "Празнувай постижението. Върни се у дома. Радвай се със семейството.",
    "cardSymbolism": [
      "Венец от цветя – портал към нов етап, завършеност",
      "Хората танцуват – радост, свобода, социални връзки",
      "Мост и замък – сигурност, безопасност",
      "Плодове и цветя – изобилие, красота"
    ],
    "reversed": "Липса на стабилност, отменен празник, самота",
    "planet": "Венера",
    "zodiac_sign": "Лъв",
    "as_situation": "Завръщане у дома. Празнуване на успех. Сватба. Стабилност.",
    "as_lesson": "След дълъг път, заслужаваш да празнуваш."
  },
  {
    "card_id": "five_wands",
    "name": "Петица Жезли",
    "name_en": "Five of Wands",
    "number": "5",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-05-five.jpg",
    "keywords": "Конфликт, съперничество, борба, спорове",
    "this_is": "конкуренцията, борбата, конфликта на егота.",
    "general_meaning": "Въвлечен си в битка за надмощие. Всички искат да докажат своето. Понякога трябва да избереш битките си.",
    "advice": "Не избягвай конфликта, но не го търси. Защити позицията си.",
    "cardSymbolism": [
      "Петима мъже с жезли – борба, но никой не е победен",
      "Различни посоки – липса на обща цел, хаотична енергия",
      "Жълто и зелено – енергия и растеж през борба"
    ],
    "reversed": "Край на конфликт, помирение, мир",
    "planet": "Сатурн",
    "zodiac_sign": "Лъв",
    "as_situation": "Конфликт на работното място. Спорове. Съперничество.",
    "as_lesson": "Понякога трябва да се бориш за позицията си."
  },
  {
    "card_id": "six_wands",
    "name": "Шестица Жезли",
    "name_en": "Six of Wands",
    "number": "6",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-06-six.jpg",
    "keywords": "Победа, признание, успех, обществено одобрение",
    "this_is": "победата, признанието, успеха.",
    "general_meaning": "След битката идва победата. Получаваш признание и всички виждат успеха ти. Гордей се.",
    "advice": "Приеми признанието. Ти го заслужаваш. Гордей се с успеха си.",
    "cardSymbolism": [
      "Конник с венец – победител, увенчан с лаври",
      "Жезъл с венец – трофей, показва го на всички",
      "Тълпата – хората, които признават успеха",
      "Бял кон – чистота на победата"
    ],
    "reversed": "Провал, липса на признание, срам",
    "planet": "Юпитер",
    "zodiac_sign": "Лъв",
    "as_situation": "Успех, който всички виждат. Признание. Победа.",
    "as_lesson": "Успехът е сладък, когато е споделен."
  },
  {
    "card_id": "seven_wands",
    "name": "Седмица Жезли",
    "name_en": "Seven of Wands",
    "number": "7",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-07-seven.jpg",
    "keywords": "Защита на позиция, съпротива, смелост сам срещу всички",
    "this_is": "защитата, отстояването на позиции, предизвикателство.",
    "general_meaning": "Ти си на върха и трябва да защитаваш позицията си от тези, които искат да те свалят. Не се предавай.",
    "advice": "Не се предавай. Дръж позицията. Ти си по-силен, отколкото си мислиш.",
    "cardSymbolism": [
      "Човек на хълм – заел е позицията си, но е уязвим",
      "Жезъл насочен надолу – защитава се, отблъсква нападението",
      "Шест жезли в земята – минали битки, които е водил",
      "Динамична поза – нужно е бързо мислене"
    ],
    "reversed": "Предаване, отстъпление, слабост",
    "planet": "Марс",
    "zodiac_sign": "Стрелец",
    "as_situation": "Защитаваш позицията си. Сам си срещу всички. Не се предаваш.",
    "as_lesson": "Понякога трябва да устоиш сам, дори и всички да са срещу теб."
  },
  {
    "card_id": "eight_wands",
    "name": "Осмица Жезли",
    "name_en": "Eight of Wands",
    "number": "8",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-08-eight.jpg",
    "keywords": "Бързина, действие, движение, неща, които се случват едновременно",
    "this_is": "бързината, движението, новините, стремителния напредък.",
    "general_meaning": "Нещата се случват бързо. Полети с вятъра. Очаквай новини или внезапно развитие.",
    "advice": "Действай бързо. Нещата се случват сега. Хвани вълната.",
    "cardSymbolism": [
      "Осем жезли във въздуха – неудържими, насочени към целта",
      "Реката – спокойствие, но действието е бързо",
      "Открито поле – няма препятствия",
      "Жезли към земята – идеите скоро ще се материализират"
    ],
    "reversed": "Забавяне, спиране, застой",
    "planet": "Меркурий",
    "zodiac_sign": "Стрелец",
    "as_situation": "Всичко се случва бързо. Много събития. Комуникация, новини.",
    "as_lesson": "Понякога трябва да се оставиш на темпото на живота."
  },
  {
    "card_id": "nine_wands",
    "name": "Деветка Жезли",
    "name_en": "Nine of Wands",
    "number": "9",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-09-nine.jpg",
    "keywords": "Устойчивост, последна линия на отбрана, издръжливост",
    "this_is": "устойчивостта, границите, последната линия на защита.",
    "general_meaning": "Уморен си, но все още стоиш. Това е последната битка. Дръж се, краят на усилията наближава.",
    "advice": "Дръж се. Почти си там. Не се предавай в последния момент.",
    "cardSymbolism": [
      "Човек подпрян на жезъл – уморен, наранен, но все още прав",
      "Превръзка – ранен е, но продължава",
      "Осем жезли зад гърба – минали битки, които го закрилят",
      "Поза – чака, дебне, очаква следващия проблем"
    ],
    "reversed": "Предаване, изтощение, край на силите",
    "planet": "Луна",
    "zodiac_sign": "Стрелец",
    "as_situation": "Последна битка. Умора, но не се предаваш. Издръжливост.",
    "as_lesson": "Дори когато си ранен, можеш да продължиш."
  },
  {
    "card_id": "ten_wands",
    "name": "Десетка Жезли",
    "name_en": "Ten of Wands",
    "number": "10",
    "arcana": "Малки аркани - Жезли",
    "filter": "wands",
    "image": "images/wands-10-ten.jpg",
    "keywords": "Претоварване, бреме, твърде много отговорности",
    "this_is": "бремето, претоварването, прекалената отговорност.",
    "general_meaning": "Носиш твърде много на гърба си. Време е да предадеш част от товара или да спреш да поемаш всичко сам.",
    "advice": "Прекалено е. Пусни част от тежестта. Не можеш да носиш всичко сам.",
    "cardSymbolism": [
      "Прегърбен човек с 10 жезъла – бреме, не вижда нищо друго",
      "Къща в далечината – целта е близо, но може да не стигне",
      "Жезли закриват гледката – фокус само върху задълженията",
      "Равна земя – пътят е равен, но тежестта го прави невъзможен"
    ],
    "reversed": "Освобождаване от бреме, по-малко отговорности",
    "planet": "Сатурн",
    "zodiac_sign": "Стрелец",
    "as_situation": "Носиш твърде много отговорности. Претоварен си. Трябва да пуснеш.",
    "as_lesson": "Не можеш да носиш всичко сам. Понякога трябва да пуснеш."
  },
  {
    "card_id": "page_wands",
    "name": "Паж Жезли",
    "name_en": "Page of Wands",
    "number": "",
    "arcana": "Малки аркани - Пажове",
    "filter": "pages",
    "image": "images/wands-11-page.jpg",
    "keywords": "Ентусиазъм, новини, свежа енергия, любопитство",
    "this_is": "ентусиазма, изследването, вестител на новини.",
    "general_meaning": "Нова идея или нов проект те вълнува. Имаш чиста енергия да започнеш нещо вдъхновяващо.",
    "advice": "Запали се за нещо ново. Сподели идеите си. Енергията ти е заразителна.",
    "cardSymbolism": [
      "Млад човек с жезъл – свежест, ентусиазъм",
      "Гледа нагоре – търси вдъхновение, идеи",
      "Жезъл – потенциал за действие",
      "Пейзаж – отворени възможности"
    ],
    "reversed": "Липса на ентусиазъм, лоши новини, отлагане, разочарование в началото",
    "planet": "Меркурий",
    "zodiac_sign": "Лъв",
    "as_situation": "Получаваш добра новина. Нова идея те запалва. Начало на проект с ентусиазъм.",
    "as_lesson": "Ентусиазмът е гориво. Не го губи, дори и другите да те наричат наивен."
  },
  {
    "card_id": "knight_wands",
    "name": "Рицар Жезли",
    "name_en": "Knight of Wands",
    "number": "",
    "arcana": "Малки аркани - Рицари",
    "filter": "knights",
    "image": "images/wands-12-knight.jpg",
    "keywords": "Импулсивност, страст, бързо движение, устрем",
    "this_is": "действието, импулсивността, пътуването, страстта.",
    "general_meaning": "Действай бързо и смело, но внимавай да не прегазиш всички с ентусиазма си. Страстта води напред.",
    "advice": "Действай сега, без да се бавиш. Рискувай. Страстта ти ще те отведе там, където трябва.",
    "cardSymbolism": [
      "Рицар на кон – бързина, устрем",
      "Пламъци – страст, енергия",
      "Конят – неудържимо движение",
      "Броня – защита в битката"
    ],
    "reversed": "Безразсъдство, агресия, импулсивни грешки, недовършени проекти",
    "planet": "Марс",
    "zodiac_sign": "Стрелец",
    "as_situation": "Бързо движение напред. Ново начало с пълна газ. Пътуване, промяна, риск.",
    "as_lesson": "Понякога трябва да действаш, без да мислиш. Страхът убива повече мечти отколкото провалът."
  },
  {
    "card_id": "queen_wands",
    "name": "Царица Жезли",
    "name_en": "Queen of Wands",
    "number": "",
    "arcana": "Малки аркани - Царици",
    "filter": "queens",
    "image": "images/wands-13-queen.jpg",
    "keywords": "Топлина, харизма, увереност, вдъхновение за другите",
    "this_is": "увереността, топлината, харизмата, независимостта.",
    "general_meaning": "Тя грее отвътре. Притежаваш самочувствие и привличаш хората с топлината си. Твориш смело.",
    "advice": "Бъди себе си - топло и уверено. Вдъхновявай другите с примера си. Ти си светлина.",
    "cardSymbolism": [
      "Слънчоглед – обърнат към светлината, оптимизъм",
      "Жезъл – власт, лидерство",
      "Трон – увереност, стабилност",
      "Лъв – сила, смелост"
    ],
    "reversed": "Ревност, егоцентризъм, манипулация, нужда от внимание, изгаряне",
    "planet": "Слънце",
    "zodiac_sign": "Лъв",
    "as_situation": "Успех, признание, вдъхновение. Ти си в центъра на вниманието и се справяш чудесно.",
    "as_lesson": "Когато светиш отвътре, ти запалваш и другите. Споделяй светлината си."
  },
  {
    "card_id": "king_wands",
    "name": "Цар Жезли",
    "name_en": "King of Wands",
    "number": "",
    "arcana": "Малки аркани - Царе",
    "filter": "kings",
    "image": "images/wands-14-king.jpg",
    "keywords": "Лидерство, визия, зрялост, опитомен огън",
    "this_is": "лидерството, визията, предприемаческия дух, власт.",
    "general_meaning": "Ти си този, който води другите. Имаш визия и авторитет да я осъществиш. Действай като лидер.",
    "advice": "Поеми лидерството. Имаш визия - следвай я. Води другите, но не ги тъпчи.",
    "cardSymbolism": [
      "Трон – власт, авторитет",
      "Цъфтящ жезъл – опитомен огън, зрялост",
      "Гущер – мъдрост, трансформация",
      "Лъв – сила, лидерство"
    ],
    "reversed": "Тирания, его, злоупотреба с власт, изпепеляване на другите",
    "planet": "Юпитер",
    "zodiac_sign": "Стрелец",
    "as_situation": "Поемаш лидерство. Водеща роля в проект. Време за визия и дългосрочни планове.",
    "as_lesson": "Истинският лидер не крещи - той свети и другите го следват."
  },
  {
    "card_id": "ace_cups",
    "name": "Асо Купи",
    "name_en": "Ace of Cups",
    "number": "1",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-01-ace.jpg",
    "keywords": "Начало на любов, ново чувство, отворено сърце, емоционален дар",
    "this_is": "любовта, новите чувства, емоционалната пълнота.",
    "general_meaning": "Отваряш сърцето си за любов. Ново чувство, връзка или дълбока емоционална радост идва към теб.",
    "advice": "Отвори сърцето си. Приеми любовта. Не се страхувай да обичаш.",
    "cardSymbolism": [
      "Ръка от облак държи чаша – дар свише, Божествена любов",
      "Преливаща чаша – изобилие от чувства",
      "Гълъб – Свети Дух, мир",
      "Водна лилия – духовност, чистота"
    ],
    "reversed": "Блокирани емоции, затворено сърце, страх от любов, емоционална празнота",
    "planet": "Венера",
    "zodiac_sign": "Рак",
    "as_situation": "Ново запознанство, влюбване. Получаваш любов. Сърцето ти се отваря.",
    "as_lesson": "Любовта идва, когато не я търсиш. Просто отвори сърцето си."
  },
  {
    "card_id": "two_cups",
    "name": "Двойка Купи",
    "name_en": "Two of Cups",
    "number": "2",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-02-two.jpg",
    "keywords": "Среща, връзка, взаимност, влюбване, партньорство",
    "this_is": "връзката, партньорството, взаимността.",
    "general_meaning": "Среща на две души. Това е карта на любовта, приятелството или всяко дълбоко партньорство, основано на уважение.",
    "advice": "Протегни ръка. Свържи се. Любовта е в срещата.",
    "cardSymbolism": [
      "Мъж и жена – Йин и Ян, свещената венчавка",
      "Купите издигнати – поздрав, тост за любовта",
      "Кадуцей – баланс, изцеление, сливане на енергии",
      "Крилат лъв – страст, която пази връзката"
    ],
    "reversed": "Раздяла, дисхармония, невзаимност, еднопосочна любов",
    "planet": "Венера",
    "zodiac_sign": "Рак",
    "as_situation": "Начало на връзка. Среща с човек, с когото имаш химия. Помирение.",
    "as_lesson": "Любовта е равен обмен. Даваш и получаваш."
  },
  {
    "card_id": "three_cups",
    "name": "Тройка Купи",
    "name_en": "Three of Cups",
    "number": "3",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-03-three.jpg",
    "keywords": "Празник, приятелство, радост, споделено щастие",
    "this_is": "приятелството, празненството, общността.",
    "general_meaning": "Празнуваш с приятели. Радостта е по-голяма, когато е споделена. Време за веселие и свързване.",
    "advice": "Празнувай с приятели. Сподели радостта си. Не бъди сам в щастието.",
    "cardSymbolism": [
      "Три жени вдигат купи – приятелски кръг, танц",
      "Плодове – изобилие, плодородие, реколта",
      "Вдигнати купи – тост за успеха и щастието",
      "Поза – ритъм и хармония"
    ],
    "reversed": "Самота, изолация, клюки, прекалено много празненства",
    "planet": "Меркурий",
    "zodiac_sign": "Рак",
    "as_situation": "Празненство, среща с приятели. Радостни събития. Бременност.",
    "as_lesson": "Щастието, споделено с други, е по-голямо."
  },
  {
    "card_id": "four_cups",
    "name": "Четворка Купи",
    "name_en": "Four of Cups",
    "number": "4",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-04-four.jpg",
    "keywords": "Апатия, недоволство, отегчение, пропуснати възможности",
    "this_is": "апатията, неудовлетвореността, преосмислянето.",
    "general_meaning": "Гледаш това, което нямаш, и не виждаш какво ти се предлага. Отвори очи за благословиите пред теб.",
    "advice": "Огледай се. Може би това, което търсиш, вече е пред теб. Стани от апатията.",
    "cardSymbolism": [
      "Човек под дърво – в покой, но и в застой",
      "Три купи пред него – това, което има, но не го радва",
      "Ръка подава четвърта – нов шанс, нова любов",
      "Поза – отказ, затвореност, не вижда какво му се дава"
    ],
    "reversed": "Прозрение, излизане от апатията, приемане на предложение",
    "planet": "Луна",
    "zodiac_sign": "Рак",
    "as_situation": "Недоволство, отегчение. Не виждаш възможностите пред себе си. Апатия.",
    "as_lesson": "Понякога не виждаме какво имаме, защото сме се фокусирали върху това, което ни липсва."
  },
  {
    "card_id": "five_cups",
    "name": "Петица Купи",
    "name_en": "Five of Cups",
    "number": "5",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-05-five.jpg",
    "keywords": "Загуба, съжаление, скръб, фокус върху това, което липсва",
    "this_is": "загубата, скръбта, съжалението, фокуса върху негативното.",
    "general_meaning": "Скърбиш за разлятото, но зад теб все още има пълни чаши. Позволи си да скърбиш, после обърни се.",
    "advice": "Позволи си да скърбиш, но после погледни назад. Има още нещо, което можеш да спасиш.",
    "cardSymbolism": [
      "Човек в черно – траур, депресия",
      "Три разлети купи – загуба, болка, сълзи",
      "Две прави купи зад гърба – това, което е останало",
      "Мост – възможност за преминаване към нов етап"
    ],
    "reversed": "Приемане на загубата, излизане от скръбта, започване отново",
    "planet": "Марс",
    "zodiac_sign": "Скорпион",
    "as_situation": "Загуба, раздяла, скръб. Фокусиран си върху това, което си загубил.",
    "as_lesson": "Плачи за загубата, но после обърни се - не всичко е загубено."
  },
  {
    "card_id": "six_cups",
    "name": "Шестица Купи",
    "name_en": "Six of Cups",
    "number": "6",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-06-six.jpg",
    "keywords": "Носталгия, спомени, детство, чисти чувства, прошка",
    "this_is": "носталгията, спомените, детството, простотата.",
    "general_meaning": "Връщаш се към миналото – спомени, стари приятели или прости радости. Но внимавай да не живееш само там.",
    "advice": "Приеми миналото с обич, но не оставай там. Прости и продължи.",
    "cardSymbolism": [
      "Дете дава чаша – безкористен дар, подарък от сърце",
      "Цветя – чистота, невинност",
      "Къща в далечината – дом от детството, сигурност",
      "Улица с цветя – приятен път към миналото"
    ],
    "reversed": "Зацикляне в миналото, невъзможност да продължиш, детска незрялост",
    "planet": "Слънце",
    "zodiac_sign": "Скорпион",
    "as_situation": "Среща с човек от миналото. Носталгия. Връщане в родното място. Прошка.",
    "as_lesson": "Миналото ни учи, но не трябва да живеем в него."
  },
  {
    "card_id": "seven_cups",
    "name": "Седмица Купи",
    "name_en": "Seven of Cups",
    "number": "7",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-07-seven.jpg",
    "keywords": "Илюзии, объркване, много избори, фантазии",
    "this_is": "илюзиите, изкушенията, фантазиите, многото възможности.",
    "general_meaning": "Мечтаеш, но не всичко е реално. Имаш много избори, но някои са илюзия. Задръж краката си на земята.",
    "advice": "Изчисти илюзиите. Фокусирай се върху едно нещо. Не всички пътища водят натам, накъдето изглежда.",
    "cardSymbolism": [
      "Човек – сянка, която не знае кое е реално",
      "Седем купи в облаците – възможности, които не са на земята",
      "Символи в купите – мечти и страхове (замък, бижута, дракон)",
      "Облаци – нестабилност, липса на твърда почва"
    ],
    "reversed": "Яснота, избор, фокус, излизане от илюзиите",
    "planet": "Венера",
    "zodiac_sign": "Скорпион",
    "as_situation": "Много възможности, не знаеш кое да избереш. Илюзии, фантазии.",
    "as_lesson": "Не всичко, което блести, е злато. Научи се да различаваш истината от илюзията."
  },
  {
    "card_id": "eight_cups",
    "name": "Осмица Купи",
    "name_en": "Eight of Cups",
    "number": "8",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-08-eight.jpg",
    "keywords": "Напускане, търсене на смисъл, отказ от познатото",
    "this_is": "напускането, търсенето на нещо повече, отдалечаването.",
    "general_meaning": "Оставяш зад себе си това, което вече не те удовлетворява. Тръгваш да търсиш нещо по-дълбоко и смислено.",
    "advice": "Ако не си щастлив, тръгни. Има нещо повече. Не се страхувай да оставиш познатото.",
    "cardSymbolism": [
      "Гръб на човек – обърнат към миналото, върви напред",
      "Осем купи подредени – една липсва, той търси нещо",
      "Червено наметало – страст, която го кара да върви",
      "Планини и луна – духовен път, търсене"
    ],
    "reversed": "Страх от тръгване, зацикляне, невъзможност да напуснеш",
    "planet": "Сатурн",
    "zodiac_sign": "Риби",
    "as_situation": "Напускаш познатото, за да търсиш нещо повече. Край на връзка или работа.",
    "as_lesson": "Понякога трябва да оставиш всичко, за да намериш себе си."
  },
  {
    "card_id": "nine_cups",
    "name": "Деветка Купи",
    "name_en": "Nine of Cups",
    "number": "9",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-09-nine.jpg",
    "keywords": "Изпълнено желание, удовлетворение, малко щастие",
    "this_is": "удовлетворението, желанията, \"карта на изпълнените мечти\".",
    "general_meaning": "Имаш всичко, което си искал. Чувстваш се доволен и щастлив. Наслади се на постигнатото.",
    "advice": "Радвай се на това, което имаш. Ти го заслужаваше. Празнувай малките победи.",
    "cardSymbolism": [
      "Човек със скръстени ръце – самодоволство, гордост",
      "Девет купи зад него – трофеи, изобилие",
      "Жълт фон – светлина, радост",
      "Тюрбан – мъдрец, постигнал целта"
    ],
    "reversed": "Повърхностно щастие, неудовлетвореност, липса на нещо",
    "planet": "Юпитер",
    "zodiac_sign": "Риби",
    "as_situation": "Получаваш това, което искаш. Удовлетворение. Сбъднато желание.",
    "as_lesson": "Искай, и ще ти се даде. Но внимавай какво си пожелаваш."
  },
  {
    "card_id": "ten_cups",
    "name": "Десетка Купи",
    "name_en": "Ten of Cups",
    "number": "10",
    "arcana": "Малки аркани - Купи",
    "filter": "cups",
    "image": "images/cups-10-ten.jpg",
    "keywords": "Върховно щастие, хармония, семейство, истинска любов",
    "this_is": "щастието, хармонията, семейното блаженство, цялост.",
    "general_meaning": "Пълно емоционално щастие. Хармония в дома, семейството и връзките. Това е картата на истинския \"дом\".",
    "advice": "Цени семейството си. Радвай се на хармонията. Това е върхът.",
    "cardSymbolism": [
      "Десет купи в дъга – завършеност, съвършенство",
      "Семейство – хармония, обич, заедност",
      "Река – спокойствие, поток на живота",
      "Къща с градина – дом, пълен с живот и радост"
    ],
    "reversed": "Дисхармония в семейството, разпадане, нещастие, самота",
    "planet": "Марс",
    "zodiac_sign": "Риби",
    "as_situation": "Семейно щастие. Хармония в дома. Истинска любов. Пълнота.",
    "as_lesson": "Истинското щастие е в обичта, която споделяш с другите."
  },
  {
    "card_id": "page_cups",
    "name": "Паж Купи",
    "name_en": "Page of Cups",
    "number": "",
    "arcana": "Малки аркани - Пажове",
    "filter": "pages",
    "image": "images/cups-11-page.jpg",
    "keywords": "Мечтател, емоционално послание, творчество, чувствителност",
    "this_is": "креативността, чувствителността, предложение за любов.",
    "general_meaning": "Получаваш нежно предложение или покана от сърце. Бъди отворен за нови емоционални преживявания.",
    "advice": "Отвори сърцето си за новото. Приеми посланието. Бъди нежен със себе си.",
    "cardSymbolism": [
      "Млад човек с чаша – чувствителност, отвореност",
      "Рибка в чашата – послание от подсъзнанието",
      "Цветя – творчество, красота",
      "Море – емоции, дълбочина"
    ],
    "reversed": "Емоционална незрялост, блокирани чувства, лоши новини, разочарование в любовта",
    "planet": "Луна",
    "zodiac_sign": "Рак",
    "as_situation": "Получаваш емоционално послание - признание, покана за среща. Ново чувство се ражда.",
    "as_lesson": "Не се срамувай от чувствата си. Те са твоята сила, не слабост."
  },
  {
    "card_id": "knight_cups",
    "name": "Рицар Купи",
    "name_en": "Knight of Cups",
    "number": "",
    "arcana": "Малки аркани - Рицари",
    "filter": "knights",
    "image": "images/cups-12-knight.jpg",
    "keywords": "Романтик, ухажване, следване на сърцето, идеализъм",
    "this_is": "романтиката, чара, поканата, следване на сърцето.",
    "general_meaning": "Идва романтичен жест или предложение. Следвай сърцето си, дори да изглежда непрактично. Красотата е в жеста.",
    "advice": "Направи романтичната крачка. Кажи какво чувстваш. Бъди смел в любовта.",
    "cardSymbolism": [
      "Рицар на кон – идеализъм, търсене",
      "Чаша в ръка – предлага любов, емоция",
      "Бял кон – чисти намерения",
      "Река – емоции, чувства"
    ],
    "reversed": "Разочарование в любовта, измама, фалшив романтик, емоционална незрялост",
    "planet": "Венера",
    "zodiac_sign": "Скорпион",
    "as_situation": "Поява на романтичен интерес. Предложение за среща, покана. Някой идва при теб с любов.",
    "as_lesson": "Любовта си струва риска. Следвай сърцето, дори и да изглеждаш глупаво."
  },
  {
    "card_id": "queen_cups",
    "name": "Царица Купи",
    "name_en": "Queen of Cups",
    "number": "",
    "arcana": "Малки аркани - Царици",
    "filter": "queens",
    "image": "images/cups-13-queen.jpg",
    "keywords": "Емпатия, интуиция, грижа, дълбока емоционалност",
    "this_is": "интуицията, емпатията, грижата, емоционалната дълбочина.",
    "general_meaning": "Ти си във връзка с емоциите си. Грижиш се за другите с разбиране и имаш дълбока интуиция.",
    "advice": "Слушай сърцето си. Грижи се за другите, но не забравяй себе си. Вярвай на интуицията.",
    "cardSymbolism": [
      "Затворена чаша – дълбоки, контролирани емоции",
      "Трон – увереност, стабилност",
      "Вода – емоции, подсъзнание",
      "Миди – чувствителност, защита"
    ],
    "reversed": "Емоционално преливане, удавяне в чувства, манипулация, неконтролируеми емоции",
    "planet": "Луна",
    "zodiac_sign": "Рак",
    "as_situation": "Нужда от емоционална подкрепа. Грижа за близък. Време за интуиция, не за логика.",
    "as_lesson": "Истинската сила е в способността да обичаш и да слушаш, без да съдиш."
  },
  {
    "card_id": "king_cups",
    "name": "Цар Купи",
    "name_en": "King of Cups",
    "number": "",
    "arcana": "Малки аркани - Царе",
    "filter": "kings",
    "image": "images/cups-14-king.jpg",
    "keywords": "Емоционална зрялост, мъдрост, контрол над чувствата",
    "this_is": "емоционалния баланс, мъдростта, състраданието, контрол над чувствата.",
    "general_meaning": "Управляваш емоциите си с мъдрост. Умееш да даваш съвет и да бъдеш стабилен в бурята от чувства.",
    "advice": "Бъди спокоен в бурята. Изслушвай, без да се включваш емоционално. Ти си скалата.",
    "cardSymbolism": [
      "Трон върху вода – контрол над емоциите",
      "Чаша – емоции, чувства",
      "Риба – творчество, подсъзнание",
      "Корал – дълбочина, мъдрост"
    ],
    "reversed": "Емоционална студенина, манипулация, потиснати чувства, неспособност да обичаш",
    "planet": "Нептун",
    "zodiac_sign": "Риби",
    "as_situation": "Контрол над емоциите в трудна ситуация. Способност да помагаш на другите, без да се удавяш.",
    "as_lesson": "Истинската зрялост е да чувстваш дълбоко, но да не позволяваш на чувствата да те управляват."
  },
  {
    "card_id": "ace_swords",
    "name": "Асо Мечове",
    "name_en": "Ace of Swords",
    "number": "1",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-01-ace.jpg",
    "keywords": "Прозрение, яснота, истина, момент на разбиране",
    "this_is": "прозрението, яснотата, новата идея, истината.",
    "general_meaning": "Момент на прозрение. Истината изведнъж става ясна като бял ден. Тя може да освободи, но и да прободе.",
    "advice": "Потърси истината. Тя е болезнена, но необходима.",
    "cardSymbolism": [
      "Ръка от облак държи меч – божествена намеса, идея свише",
      "Корона – власт, успех, яснота",
      "Маслинова клонка – победа, мир чрез истина",
      "Планини – трудностите, които очакват"
    ],
    "reversed": "Заблуда, лъжа, объркване",
    "planet": "Меркурий",
    "zodiac_sign": "Везни",
    "as_situation": "Момент на прозрение. Разбираш истината. Яснота след дълго объркване.",
    "as_lesson": "Истината освобождава, но първо пронизва."
  },
  {
    "card_id": "two_swords",
    "name": "Двойка Мечове",
    "name_en": "Two of Swords",
    "number": "2",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-02-two.jpg",
    "keywords": "Безизходица, труден избор, блокирано решение",
    "this_is": "задънена улица, нерешителност, защита на сърцето.",
    "general_meaning": "Отказваш да видиш истината или не можеш да избереш. Свали превръзката от очите си, за да продължиш.",
    "advice": "Свали превръзката. Избери. Не можеш да стоиш вечно в безизходица.",
    "cardSymbolism": [
      "Жена със завързани очи – не иска да вижда истината",
      "Два меча скръстени – защита, блокиране на сърцето и ума",
      "Седи неподвижно – застой, безизходица",
      "Море зад нея – бурни емоции, които не вижда"
    ],
    "reversed": "Избор, яснота, решение",
    "planet": "Луна",
    "zodiac_sign": "Везни",
    "as_situation": "Труден избор. Не виждаш ясно. Блокирано решение.",
    "as_lesson": "Понякога трябва да свалиш превръзката и да избереш, дори и да не виждаш ясно."
  },
  {
    "card_id": "three_swords",
    "name": "Тройка Мечове",
    "name_en": "Three of Swords",
    "number": "3",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-03-three.jpg",
    "keywords": "Разбито сърце, болка, тъга, нараняване",
    "this_is": "разбито сърце, болка, тъга, предателство.",
    "general_meaning": "Болката е реална. Позволи си да преживееш тъгата, защото това е първата стъпка към изцелението.",
    "advice": "Позволи си да скърбиш. Болката е истинска. Но няма да продължи вечно.",
    "cardSymbolism": [
      "Сърце пронизано от три меча – чиста, силна емоционална болка",
      "Дъжд/облаци – тъга, депресия, студ",
      "Сив фон – самота, липса на надежда",
      "Три меча – болка в минало, настояще, бъдеще"
    ],
    "reversed": "Излекуване, прошка, приемане на болката",
    "planet": "Сатурн",
    "zodiac_sign": "Везни",
    "as_situation": "Раздяла, загуба на любим човек. Болка. Скръб.",
    "as_lesson": "Болката е част от живота. Трябва да я приемеш, за да оздравееш."
  },
  {
    "card_id": "four_swords",
    "name": "Четворка Мечове",
    "name_en": "Four of Swords",
    "number": "4",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-04-four.jpg",
    "keywords": "Почивка, уединение, медитация, възстановяване",
    "this_is": "почивка, уединение, възстановяване, медитация.",
    "general_meaning": "След битката идва време за почивка. Отдръпни се, за да събереш сили и да изчистиш ума си.",
    "advice": "Почини си. Оттегли се. Събери сили. Битката може да изчака.",
    "cardSymbolism": [
      "Рисуван рицар на гробница – почивка, смърт на егото",
      "Три меча на стената – окачени, не се използват",
      "Един меч под него – готовност, ако се наложи",
      "Витражи – духовност, вяра, спасение"
    ],
    "reversed": "Прегаряне, невъзможност за почивка, безсъние",
    "planet": "Юпитер",
    "zodiac_sign": "Водолей",
    "as_situation": "Време за почивка. Оттегляне. Медитация. Възстановяване.",
    "as_lesson": "След битка идва време за почивка. Не можеш да се биеш вечно."
  },
  {
    "card_id": "five_swords",
    "name": "Петица Мечове",
    "name_en": "Five of Swords",
    "number": "5",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-05-five.jpg",
    "keywords": "Празна победа, унижение на другия, горчив успех",
    "this_is": "конфликт, поражение, победа на всяка цена, тровене.",
    "general_meaning": "Спечелил си, но каква беше цената? Оставил си другите в прахта. Понякога \"победата\" е празна.",
    "advice": "Помисли дали си струва да унищожиш другия, за да спечелиш. Победата може да те остави сам.",
    "cardSymbolism": [
      "Победител с три меча – усмихнат, арогантен",
      "Двама отзад плачат – унизени, победени",
      "Облаци – турбулентност, разкъсана енергия",
      "Опустошена земя – след битката няма нищо ценно"
    ],
    "reversed": "Помирение, прошка, край на конфликт",
    "planet": "Венера",
    "zodiac_sign": "Водолей",
    "as_situation": "Спечелена битка, но загубена война. Празна победа. Остана сам.",
    "as_lesson": "Понякога победата не си струва цената."
  },
  {
    "card_id": "six_swords",
    "name": "Шестица Мечове",
    "name_en": "Six of Swords",
    "number": "6",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-06-six.jpg",
    "keywords": "Преход, пътуване, оставяне на старото зад гърба",
    "this_is": "преход, пътуване към по-добро, напускане на бурята.",
    "general_meaning": "Оставяш трудностите зад гърба си и бавно се насочваш към по-спокойни води. Пътят е бавен, но води надалеч.",
    "advice": "Време е да тръгнеш. Остави старото зад гърба. Пред теб е по-добро място.",
    "cardSymbolism": [
      "Жена и дете в лодка – уязвимост, нужда от закрила",
      "Лодкар – преход между светове",
      "Шест меча в лодката – миналото, което носят със себе си",
      "Тиха вода – от бурно към спокойно"
    ],
    "reversed": "Зацикляне, невъзможност да тръгнеш",
    "planet": "Меркурий",
    "zodiac_sign": "Водолей",
    "as_situation": "Напускаш старото. Пътуваш към ново. Преходен период.",
    "as_lesson": "Понякога трябва да оставиш всичко и да тръгнеш, за да оцелееш."
  },
  {
    "card_id": "seven_swords",
    "name": "Седмица Мечове",
    "name_en": "Seven of Swords",
    "number": "7",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-07-seven.jpg",
    "keywords": "Измама, хитрост, кражба, нечестна игра",
    "this_is": "измама, хитрост, стратегия, бягство от отговорност.",
    "general_meaning": "Опитваш се да избягаш или да излъжеш системата. Понякога е нужно, но внимавай да не излъжеш себе си.",
    "advice": "Внимавай. Някой може да те мами. Провери два пъти.",
    "cardSymbolism": [
      "Бяга с пет меча – опитва да отмъкне колкото може",
      "Два меча в земята – оставени, не е успял да ги вземе",
      "Лагер в далечината – хората, които мами",
      "Поглежда назад – страх да не бъде хванат"
    ],
    "reversed": "Признание, връщане на откраднатото, честност",
    "planet": "Луна",
    "zodiac_sign": "Близнаци",
    "as_situation": "Някой те мами. Има измама. Не всичко е както изглежда.",
    "as_lesson": "Понякога трябва да внимаваш - не всички играят честно."
  },
  {
    "card_id": "eight_swords",
    "name": "Осмица Мечове",
    "name_en": "Eight of Swords",
    "number": "8",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-08-eight.jpg",
    "keywords": "Парализа, чувство за безизходица, страхове в главата",
    "this_is": "ограничение, безсилие, чувство на капан (в ума).",
    "general_meaning": "Чувстваш се в капан, но оковите са само в главата ти. Истината е, че можеш да си тръгнеш всеки момент.",
    "advice": "Погледни отново - може би не си толкова вързан, колкото си мислиш. Страхът те държи.",
    "cardSymbolism": [
      "Вързана жена – пълна безпомощност, но връзките са леки",
      "Осем меча около нея – въображаеми прегради",
      "Замък на хълма – свободата, целта е близо",
      "Блатиста земя – трудно, но не невъзможно"
    ],
    "reversed": "Освобождение, излизане от капана, прозрение",
    "planet": "Юпитер",
    "zodiac_sign": "Близнаци",
    "as_situation": "Чувстваш се в капан. Нямаш изход. Но всъщност оковите са в главата ти.",
    "as_lesson": "Понякога сме в капан само в собствената си глава."
  },
  {
    "card_id": "nine_swords",
    "name": "Деветка Мечове",
    "name_en": "Nine of Swords",
    "number": "9",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-09-nine.jpg",
    "keywords": "Кошмари, безсъние, тревога, мъчителни мисли",
    "this_is": "безсъние, тревога, кошмари, угризения.",
    "general_meaning": "Тревогите те измъчват нощем. Страховете ти изглеждат огромни. Това е буря в ума, която ще отмине.",
    "advice": "Това, което те измъчва, е в главата ти. Потърси помощ. Не оставай сам с мислите си.",
    "cardSymbolism": [
      "Жена в леглото – ужас, срам, отчаяние",
      "Девет меча на стената – мислите, които режат",
      "Тъмно – мрак в душата",
      "Одеяло – тежест на съдбата"
    ],
    "reversed": "Излизане от тревогата, спокойствие, мир",
    "planet": "Марс",
    "zodiac_sign": "Близнаци",
    "as_situation": "Безсъние, тревожност. Мислите не те оставят да спиш. Страхове.",
    "as_lesson": "Понякога най-големите ни врагове са мислите ни."
  },
  {
    "card_id": "ten_swords",
    "name": "Десетка Мечове",
    "name_en": "Ten of Swords",
    "number": "10",
    "arcana": "Малки аркани - Мечове",
    "filter": "swords",
    "image": "images/swords-10-ten.jpg",
    "keywords": "Дъно, пълно поражение, край, но и ново начало",
    "this_is": "дъното, предателството, краят (но и новото начало след това).",
    "general_meaning": "Стигна до дъното. Няма накъде повече надолу. Това е край, но именно тук започва нещо ново.",
    "advice": "Това е краят. Но той носи и ново начало. Стани. Слънцето изгрява отново.",
    "cardSymbolism": [
      "Човек с 10 меча в гърба – напълно победен, убит",
      "Лице на земята – срам, край",
      "Изгрев – новото начало след тъмнината",
      "Спокойна вода – бурята е преминала"
    ],
    "reversed": "Възстановяване, бавно излизане от дъното",
    "planet": "Слънце",
    "zodiac_sign": "Близнаци",
    "as_situation": "Всичко изглежда загубено. Дъното. Край.",
    "as_lesson": "Когато си на дъното, единственият път е нагоре."
  },
  {
    "card_id": "page_swords",
    "name": "Паж Мечове",
    "name_en": "Page of Swords",
    "number": "",
    "arcana": "Малки аркани - Пажове",
    "filter": "pages",
    "image": "images/swords-11-page.jpg",
    "keywords": "Любопитство, търсене на истина, наблюдателност",
    "this_is": "любопитство, бдителност, клюки, интелектуално търсене.",
    "general_meaning": "Търсиш истината с остър ум. Наблюдавай внимателно, но внимавай да не станеш клюкар.",
    "advice": "Задавай въпроси. Не приемай нищо за дадено. Търси истината - тя е някъде.",
    "cardSymbolism": [
      "Млад човек с меч – търсене на истина",
      "Вдигнат меч – готовност да защити истината",
      "Вятър – мисли, идеи",
      "Птици – комуникация, новини"
    ],
    "reversed": "Клюки, лъжи, манипулация, повърхностност, незрялост",
    "planet": "Меркурий",
    "zodiac_sign": "Водолей",
    "as_situation": "Търсиш информация, разследваш. Получаваш важни новини. Учиш нещо ново.",
    "as_lesson": "Истината те освобождава, но първо трябва да я потърсиш."
  },
  {
    "card_id": "knight_swords",
    "name": "Рицар Мечове",
    "name_en": "Knight of Swords",
    "number": "",
    "arcana": "Малки аркани - Рицари",
    "filter": "knights",
    "image": "images/swords-12-knight.jpg",
    "keywords": "Бързина, устрем, безкомпромисност, действие",
    "this_is": "агресия, прямота, бързи мисли, конфронтация.",
    "general_meaning": "Действаш бързо и агресивно, воден от убеждения. Понякога трябва да се пребориш, но не прерязвай всички връзки.",
    "advice": "Действай бързо, но не безразсъдно. Имаш устрема - насочи го правилно.",
    "cardSymbolism": [
      "Рицар на кон – бързина, устрем",
      "Вдигнат меч – готовност за битка",
      "Облаци – напрежение, конфликт",
      "Птици – мисли, идеи"
    ],
    "reversed": "Агресия, бруталност, безразсъдство, прегазване на другите, конфликти",
    "planet": "Марс",
    "zodiac_sign": "Близнаци",
    "as_situation": "Бързо действие, понякога твърде бързо. Трябва да действаш светкавично. Криза.",
    "as_lesson": "Понякога трябва да действаш бързо, но внимавай кого прегазваш по пътя."
  },
  {
    "card_id": "queen_swords",
    "name": "Царица Мечове",
    "name_en": "Queen of Swords",
    "number": "",
    "arcana": "Малки аркани - Царици",
    "filter": "queens",
    "image": "images/swords-13-queen.jpg",
    "keywords": "Ясен ум, независимост, проницателност, справедливост",
    "this_is": "независимост, остър ум, самота, истина през болка.",
    "general_meaning": "Преживяла си болката и сега си станал силен и независим. Виждаш истината ясно, дори да е сурова.",
    "advice": "Бъди прям и честен. Не се страхувай да казваш истината. Отрязвай връзките, които не работят.",
    "cardSymbolism": [
      "Вдигнат меч – истина, яснота",
      "Трон – увереност, независимост",
      "Облаци – мисли, идеи",
      "Птици – свобода, комуникация"
    ],
    "reversed": "Студенина, жестокост, манипулация, невъзможност за прошка, горчивина",
    "planet": "Венера",
    "zodiac_sign": "Везни",
    "as_situation": "Нужда от яснота и честност. Вземане на трудно решение. Край на илюзиите.",
    "as_lesson": "Истината боли, но лъжата убива. Бъди честен, дори и да те мразят за това."
  },
  {
    "card_id": "king_swords",
    "name": "Цар Мечове",
    "name_en": "King of Swords",
    "number": "",
    "arcana": "Малки аркани - Царе",
    "filter": "kings",
    "image": "images/swords-14-king.jpg",
    "keywords": "Авторитет, интелект, обективност, върховен съдия",
    "this_is": "авторитет, интелект, ред, обективна истина, закон.",
    "general_meaning": "Вземаш решения с главата, не със сърцето. Ти си авторитетът, който налага ред и истина, без емоции.",
    "advice": "Вземи решението с ума си. Бъди обективен. Не позволявай на чувствата да замъглят истината.",
    "cardSymbolism": [
      "Трон – власт, авторитет",
      "Меч – истина, справедливост",
      "Пеперуди – трансформация на мисълта",
      "Облаци – интелект, мисли"
    ],
    "reversed": "Догматизъм, студенина, жестокост, злоупотреба с власт, несправедливост",
    "planet": "Юпитер",
    "zodiac_sign": "Водолей",
    "as_situation": "Вземане на важно решение. Съд, оценка, анализ. Нужда от обективност.",
    "as_lesson": "Понякога емоциите трябва да отстъпят пред логиката. Справедливостта не е жестока - тя е точна."
  },
  {
    "card_id": "ace_pentacles",
    "name": "Асо Пентакли",
    "name_en": "Ace of Pentacles",
    "number": "1",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-01-ace.jpg",
    "keywords": "Възможност, дар, семе на нещо материално, просперитет",
    "this_is": "нови възможности, просперитет, подарък, ресурс.",
    "general_meaning": "Получаваш шанс за материален или физически просперитет. Нова работа, подарък или възможност за растеж.",
    "advice": "Хвани възможността. Тя няма да чака вечно. Новото начало идва.",
    "cardSymbolism": [
      "Ръка от облак държи пентакъл – дар от Вселената",
      "Цъфтяща градина – изобилие, природа, която ражда",
      "Пътека към планини – пътят към успеха",
      "Лилии – чистота и стремеж"
    ],
    "reversed": "Пропусната възможност, финансов проблем",
    "planet": "Сатурн",
    "zodiac_sign": "Телец",
    "as_situation": "Нова работа, повишение, финансова възможност. Получаваш нещо ценно.",
    "as_lesson": "Възможностите идват - трябва да ги видиш и да ги хванеш."
  },
  {
    "card_id": "two_pentacles",
    "name": "Двойка Пентакли",
    "name_en": "Two of Pentacles",
    "number": "2",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-02-two.jpg",
    "keywords": "Жонглиране с ресурси, баланс, приспособяване",
    "this_is": "баланс на ресурси, жонглиране, приспособяване.",
    "general_meaning": "Успяваш да жонглираш с няколко неща едновременно. Намираш баланс във финансите и времето. Бъди гъвкав.",
    "advice": "Балансирай. Не изпускай нито едното, нито другото. Животът е въртележка.",
    "cardSymbolism": [
      "Жонглира с два пентакъла – баланс, ловкост",
      "Безкрайност – вечно движение, цикъл на даване и вземане",
      "Кораби във вълни – животът се люшка",
      "Танцуваща поза – трябва да се движиш, за да запазиш равновесие"
    ],
    "reversed": "Загуба на баланс, хаос, невъзможност да управляваш",
    "planet": "Юпитер",
    "zodiac_sign": "Козирог",
    "as_situation": "Жонглираш с две неща - работа и семейство, приходи и разходи. Баланс.",
    "as_lesson": "Животът е баланс между много неща. Научи се да жонглираш."
  },
  {
    "card_id": "three_pentacles",
    "name": "Тройка Пентакли",
    "name_en": "Three of Pentacles",
    "number": "3",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-03-three.jpg",
    "keywords": "Сътрудничество, екипна работа, учене от майстори",
    "this_is": "екипна работа, майсторство, сътрудничество, учене.",
    "general_meaning": "Работиш в екип, за да създадеш нещо качествено. Учиш занаят или си признат за уменията си.",
    "advice": "Работи в екип. Учи се от майсторите. Не се страхувай да покажеш работата си.",
    "cardSymbolism": [
      "Занаятчия с работата си – майсторство, умение",
      "Двама души с планове – сътрудничество, съвет",
      "Църква – строи се нещо свято",
      "Пентакли – материал, вграден с умение"
    ],
    "reversed": "Липса на сътрудничество, его, самота в работата",
    "planet": "Марс",
    "zodiac_sign": "Козирог",
    "as_situation": "Работиш в екип. Учиш се от по-опитни. Сътрудничество.",
    "as_lesson": "Заедно можем повече, отколкото сами."
  },
  {
    "card_id": "four_pentacles",
    "name": "Четворка Пентакли",
    "name_en": "Four of Pentacles",
    "number": "4",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-04-four.jpg",
    "keywords": "Задържане, стискане, страх от загуба, алчност",
    "this_is": "задържане, спестовност, контрол, скъперничество.",
    "general_meaning": "Държиш здраво ресурсите си от страх да не ги загубиш. Понякога трябва да отвориш ръка, за да получиш повече.",
    "advice": "Пусни малко. Страхът от загуба те държи в плен. Даването не е загуба.",
    "cardSymbolism": [
      "Седи неподвижно – закостенялост, липса на гъвкавост",
      "Два под краката – стабилна основа, но и зависимост",
      "Един до сърцето – страх да пусне, държи се здраво",
      "Един на главата – мисли само за пари и притежания",
      "Град в далечината – изолиран от света"
    ],
    "reversed": "Загуба, фалит, освобождаване от стискането",
    "planet": "Слънце",
    "zodiac_sign": "Козирог",
    "as_situation": "Страх да похарчиш пари. Стискаш. Не даваш на никого.",
    "as_lesson": "Когато стискаш твърде здраво, нищо не може да дойде при теб."
  },
  {
    "card_id": "five_pentacles",
    "name": "Петица Пентакли",
    "name_en": "Five of Pentacles",
    "number": "5",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-05-five.jpg",
    "keywords": "Липса, бедност, нужда, усещане за изоставеност",
    "this_is": "трудности, липса, изолация, финансови проблеми.",
    "general_meaning": "Чувстваш се извън топлината, сам в студа на липсата. Помощ има, но трябва да я потърсиш.",
    "advice": "Имаш нужда от помощ. Поискай я. Не оставай сам в студа.",
    "cardSymbolism": [
      "Двама просяци в снега – материална и физическа липса",
      "Петолъчка на прозореца – духовна надежда, която не виждат",
      "Сняг – студ, изолация, трудност"
    ],
    "reversed": "Излизане от бедността, получаване на помощ",
    "planet": "Меркурий",
    "zodiac_sign": "Телец",
    "as_situation": "Финансови трудности. Чувстваш се изоставен. Нужда.",
    "as_lesson": "Понякога стигаме до дъното, преди да получим помощ."
  },
  {
    "card_id": "six_pentacles",
    "name": "Шестица Пентакли",
    "name_en": "Six of Pentacles",
    "number": "6",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-06-six.jpg",
    "keywords": "Щедрост, даване и вземане, помощ, благотворителност",
    "this_is": "благотворителност, даване/получаване, щедрост, баланс.",
    "general_meaning": "Време е да дадеш или да получиш помощ. Цикълът на щедростта се завърта. Дай, за да получиш.",
    "advice": "Дай, ако имаш. Приеми, ако имаш нужда. Балансът е важен.",
    "cardSymbolism": [
      "Богаташ дава – справедливост, точно разпределение",
      "Просяк коленичил – получава, благодарен",
      "Везни – баланс, всеки според нуждите",
      "Шест пентакъла – помощта е точна колкото трябва"
    ],
    "reversed": "Неравенство, несправедливост, егоизъм",
    "planet": "Луна",
    "zodiac_sign": "Телец",
    "as_situation": "Получаваш помощ. Даваш на други. Баланс.",
    "as_lesson": "Всички сме тук, за да си помагаме."
  },
  {
    "card_id": "seven_pentacles",
    "name": "Седмица Пентакли",
    "name_en": "Seven of Pentacles",
    "number": "7",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-07-seven.jpg",
    "keywords": "Търпение, изчакване, оценка на растежа",
    "this_is": "търпение, инвестиция, изчакване на растеж, земеделие.",
    "general_meaning": "Посвял си труд и сега чакаш реколтата. Не спирай да се грижиш, дори резултатите да закъсняват.",
    "advice": "Изчакай. Растежът изисква време. Оцени какво си постигнал.",
    "cardSymbolism": [
      "Млад мъж подпрян – оглежда труда си",
      "Бушуваща растителност – растеж, времето е минало",
      "Изражение – замислен, 'Струваше ли си?'",
      "Пентакли като плодове – резултат от упорит труд"
    ],
    "reversed": "Нетърпение, разочарование от резултатите",
    "planet": "Сатурн",
    "zodiac_sign": "Телец",
    "as_situation": "Чакаш резултати от труда си. Оценяваш какво си постигнал.",
    "as_lesson": "Растежът изисква време. Не бързай."
  },
  {
    "card_id": "eight_pentacles",
    "name": "Осмица Пентакли",
    "name_en": "Eight of Pentacles",
    "number": "8",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-08-eight.jpg",
    "keywords": "Усърдие, майсторство, учене чрез правене, занаят",
    "this_is": "умение, учене, усърдна работа, чиракуване.",
    "general_meaning": "Работиш усърдно, за да усъвършенстваш занаята си. Вложеното усилие ще се изплати в качество.",
    "advice": "Работи усърдно. Усъвършенствай се. Повторението е майка на знанието.",
    "cardSymbolism": [
      "Занаятчия вае пентакли – концентрация, отдаденост",
      "Завършени пентакли – това, което е постигнал",
      "Седяща поза – упорит труд",
      "Фокус върху задачата – не гледа настрани"
    ],
    "reversed": "Некачествена работа, липса на фокус",
    "planet": "Слънце",
    "zodiac_sign": "Дева",
    "as_situation": "Работиш усърдно. Учиш се. Ставаш майстор в занаята си.",
    "as_lesson": "Майсторството идва с практика, не с теория."
  },
  {
    "card_id": "nine_pentacles",
    "name": "Деветка Пентакли",
    "name_en": "Nine of Pentacles",
    "number": "9",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-09-nine.jpg",
    "keywords": "Самодостатъчност, удовлетворение, плодове на труда",
    "this_is": "самодостатъчност, лукс, сигурност, наслада от труда.",
    "general_meaning": "Постигнал си сигурност сам. Наслаждаваш се на плодовете на труда си в лукс и спокойствие.",
    "advice": "Наслади се на това, което си създал. Ти си самодостатъчен. Това е свобода.",
    "cardSymbolism": [
      "Жена в градина – успех, свобода",
      "Птица на ръка – контрол над по-висшите сфери",
      "Охлюв – бавно, но сигурно движение",
      "Ръкавица – защита, предпазливост",
      "Изобилна градина – нейният свят"
    ],
    "reversed": "Зависимост, неудовлетворение, загуба",
    "planet": "Венера",
    "zodiac_sign": "Дева",
    "as_situation": "Наслаждаваш се на резултатите. Самодостатъчен си. Нямаш нужда от никого.",
    "as_lesson": "Истинското богатство е да не се нуждаеш от никого."
  },
  {
    "card_id": "ten_pentacles",
    "name": "Десетка Пентакли",
    "name_en": "Ten of Pentacles",
    "number": "10",
    "arcana": "Малки аркани - Пентакли",
    "filter": "pentacles",
    "image": "images/pentacles-10-ten.jpg",
    "keywords": "Наследство, род, традиция, семейно богатство",
    "this_is": "наследство, семейство, богатство, традиция, дом.",
    "general_meaning": "Изградил си нещо, което остава след теб. Семейно богатство, традиции и дълготрайна сигурност.",
    "advice": "Цени семейството си. Това, което градиш, остава след теб.",
    "cardSymbolism": [
      "Старец – пазител на рода, традицията",
      "Кучета – вярност, пазачи на дома",
      "Жена и дете – младостта, бъдещето на рода",
      "Десет пентакъла – Дърво на живота, корени, род",
      "Арка – стабилност, портал към дома"
    ],
    "reversed": "Семейни проблеми, загуба на наследство, разпад на рода",
    "planet": "Меркурий",
    "zodiac_sign": "Дева",
    "as_situation": "Семейно събиране. Наследство. Сигурност, предавана през поколения.",
    "as_lesson": "Истинското богатство е в рода и традициите, които предаваме."
  },
  {
    "card_id": "page_pentacles",
    "name": "Паж Пентакли",
    "name_en": "Page of Pentacles",
    "number": "",
    "arcana": "Малки аркани - Пажове",
    "filter": "pages",
    "image": "images/pentacles-11-page.jpg",
    "keywords": "Ученик, ново начало в материалното, практичност",
    "this_is": "учене, практичност, амбиция, започване на проект.",
    "general_meaning": "Започваш да учиш нещо практично. Имаш амбиция да градиш, но тепърва събираш опит.",
    "advice": "Започни да учиш. Инвестирай в себе си. Търпеливо гради, стъпка по стъпка.",
    "cardSymbolism": [
      "Млад човек с пентакъл – учене, начало",
      "Гледа внимателно – фокус, концентрация",
      "Природа – растеж, развитие",
      "Път – посока, бъдеще"
    ],
    "reversed": "Липса на фокус, несериозно отношение към парите, пропуснати възможности",
    "planet": "Меркурий",
    "zodiac_sign": "Козирог",
    "as_situation": "Започваш да учиш нещо ново. Нова работа, нов проект. Финансово начало.",
    "as_lesson": "Всичко голямо започва от малко семе. Бъди търпелив и учи."
  },
  {
    "card_id": "knight_pentacles",
    "name": "Рицар Пентакли",
    "name_en": "Knight of Pentacles",
    "number": "",
    "arcana": "Малки аркани - Рицари",
    "filter": "knights",
    "image": "images/pentacles-12-knight.jpg",
    "keywords": "Търпение, методичност, бавен и сигурен напредък",
    "this_is": "търпение, надеждност, рутина, бавен напредък.",
    "general_meaning": "Движиш се бавно и сигурно. Може да ти липсва бързина, но никой не е по-надежден от теб на дългия път.",
    "advice": "Не бързай. Работи търпеливо. Сигурният път е бавен, но води до целта.",
    "cardSymbolism": [
      "Рицар на кон – методичност, търпение",
      "Пентакъл – фокус върху материалното",
      "Обработена земя – труд, работа",
      "Конят не бърза – бавен, но сигурен напредък"
    ],
    "reversed": "Мудност, застой, скука, липса на напредък, страх от промяна",
    "planet": "Сатурн",
    "zodiac_sign": "Дева",
    "as_situation": "Бавен, но стабилен напредък. Работа, която изисква търпение. Финансов растеж.",
    "as_lesson": "Бързата печалба е рядко сигурна. Истинското се гради бавно, но стои здраво."
  },
  {
    "card_id": "queen_pentacles",
    "name": "Царица Пентакли",
    "name_en": "Queen of Pentacles",
    "number": "",
    "arcana": "Малки аркани - Царици",
    "filter": "queens",
    "image": "images/pentacles-13-queen.jpg",
    "keywords": "Грижа, домашен уют, връзка с природата, изобилие",
    "this_is": "изобилие, грижа, практичност, връзка с природата.",
    "general_meaning": "Грижиш се за света около себе си с любов и практичност. Създаваш топлина, уют и изобилие.",
    "advice": "Грижи се за дома си и за себе си. Създавай уют. Цени малките неща.",
    "cardSymbolism": [
      "Жена в природа – връзка със земята",
      "Пентакъл – материално богатство",
      "Зайци – плодородие, изобилие",
      "Цветя – красота, растеж"
    ],
    "reversed": "Материализъм, задушаваща грижа, зависимост от материалното, изтощение",
    "planet": "Венера",
    "zodiac_sign": "Телец",
    "as_situation": "Домашен уют, семейство, грижа. Добър финансов период. Хармония в дома.",
    "as_lesson": "Истинското богатство е у дома, в уюта, в храната, споделена с любими."
  },
  {
    "card_id": "king_pentacles",
    "name": "Цар Пентакли",
    "name_en": "King of Pentacles",
    "number": "",
    "arcana": "Малки аркани - Царе",
    "filter": "kings",
    "image": "images/pentacles-14-king.jpg",
    "keywords": "Стабилност, успех, мъдрост, създадена сигурност",
    "this_is": "стабилност, успех, осигуреност, бизнесмен, изобилие.",
    "general_meaning": "Постигнал си връх в материалния свят. Ти си господарят на ресурсите, стабилен и успешен.",
    "advice": "Гради стабилност. Споделяй с другите. Ти си сигурното пристанище за много хора.",
    "cardSymbolism": [
      "Трон сред лозе – успех, стабилност",
      "Пентакъл – богатство, сигурност",
      "Грозде – плодородие, изобилие",
      "Град в далечината – империя, която е създал"
    ],
    "reversed": "Алчност, материализъм, загуба, фалит, несигурност, страх от загуба",
    "planet": "Юпитер",
    "zodiac_sign": "Козирог",
    "as_situation": "Финансов успех, стабилност. Създадена сигурност. Бизнес успех.",
    "as_lesson": "Истинският успех е не да имаш, а да си създал нещо, което остава."
  }
];


export const filters = {
  major: "Големи аркани",
  wands: "Жезли",
  cups: "Купи",
  swords: "Мечове",
  pentacles: "Пентакли",
  kings: "Царе",
  queens: "Царици",
  knights: "Рицари",
  pages: "Пажове",
  numbers: {
    "1": "Асо",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10"
  }
};

 
     
